import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { Hero } from "@/components/home/Hero";
import { ProductCard } from "@/components/ProductCard";
import { FadeIn } from "@/components/FadeIn";
import {
  SectionHeading, FeaturedCategories, LifestyleBanner, WhyChooseUs,
  Community, NewsletterSection,
} from "@/components/home/HomeSections";

const BestSellers = () => {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { is_bestseller: true, sort: "featured" } })
      .then((r) => setProducts(r.data.slice(0, 4))).catch(() => {});
  }, []);
  return (
    <section className="container-lira py-24 md:py-32" data-testid="best-sellers">
      <FadeIn><SectionHeading eyebrow="Loved by many" title="Best Sellers" cta="View all" ctaTo="/collection/all?filter=bestseller" /></FadeIn>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {products.map((p, i) => (
          <FadeIn key={p.id} delay={i * 0.08}><ProductCard product={p} /></FadeIn>
        ))}
      </div>
    </section>
  );
};

const NewArrivals = () => {
  const [products, setProducts] = useState([]);
  const railRef = useRef(null);
  useEffect(() => {
    api.get("/products", { params: { is_new: true, sort: "newest" } })
      .then((r) => setProducts(r.data)).catch(() => {});
  }, []);
  const scroll = (dir) => {
    if (railRef.current) railRef.current.scrollBy({ left: dir * 360, behavior: "smooth" });
  };
  if (products.length === 0) return null;
  return (
    <section className="py-24 md:py-32 bg-beige" data-testid="new-arrivals">
      <div className="container-lira">
        <div className="flex items-end justify-between mb-12 md:mb-16">
          <div>
            <p className="eyebrow mb-3">Just In</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">New Arrivals</h2>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={() => scroll(-1)} aria-label="Scroll left" className="h-11 w-11 grid place-items-center rounded-full border border-[#d8d1c4] hover:bg-[#1A1A1A] hover:text-white transition-colors">
              <ChevronLeft strokeWidth={1} className="h-4 w-4" />
            </button>
            <button onClick={() => scroll(1)} aria-label="Scroll right" className="h-11 w-11 grid place-items-center rounded-full border border-[#d8d1c4] hover:bg-[#1A1A1A] hover:text-white transition-colors">
              <ChevronRight strokeWidth={1} className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
      <div ref={railRef} className="flex gap-6 overflow-x-auto no-scrollbar px-6 md:px-12 snap-x">
        {products.map((p) => (
          <div key={p.id} className="min-w-[280px] w-[280px] sm:min-w-[320px] sm:w-[320px] snap-start">
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <FeaturedCategories />
      <BestSellers />
      <LifestyleBanner />
      <NewArrivals />
      <WhyChooseUs />
      <Community />
      <NewsletterSection />
    </div>
  );
}
